export const formatDate = d => [d.getFullYear(),...[d.getMonth(),d.getDate()].map(e=>(e+'').padStart(2,'0'))].join('-');
